import React from 'react';
import './ticketnumb.css'
import pic43 from'../../assets/pic43.png'
import pic44 from'../../assets/pic44.png'


const Ticketnum = ({ title, value, onChange }) => {


    const decreaseTickets = () => {
    if (value > 1) {
        onChange(value - 1);
    }

};

const increaseTickets = () => {
     onChange(value + 1);
};



    return ( 
        <fieldset className='container-input'>
            <label className='title-inputt'>{title}</label>
            <fieldset className='container-row-input-ticket-numb'>
                <button className='addcta' onClick={decreaseTickets} type="button">
                    <img className='icon-ctaa-plus' src={pic43} alt='minus'></img>
                </button>
                
                <h2 className='input-numberrr-ticket-number'>
                      {value}
                </h2>

                <button className='addcta' onClick={increaseTickets} type="button" >
                    <img className='icon-ctaa-plus' src={pic44} alt='plus'></img>
                </button>


            </fieldset>
        </fieldset>
     );
}
 
export default Ticketnum;